/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-10-15 10:32:01
 * @LastEditors: yinj
 * @LastEditTime: 2021-02-23 13:55:47
 */

import request from '@/utils/request';

const requestInstance = request();
export default {
  // 设置默认背景和颜色
  pptWrapSetSlideBackground(params) {
    return requestInstance.post('/api/schemeshow/pptWrap/setSlideBackground', params);
  },
  // 创建图片 ,pptId,slideId 必需
  slideWrapCreateSlideImage(params) {
    return requestInstance.post('/api/schemeshow/slideWrap/createSlideImage', params);
  },
  // 创建文本，pptId,slideId 必需
  slideWrapCreateSlideText(params) {
    return requestInstance.post('/api/schemeshow/slideWrap/createSlideText', params);
  },
  // 创建区域，pptId,slideId 必需
  slideWrapCreateSlideArea(params) {
    return requestInstance.post('/api/schemeshow/slideWrap/createSlideArea', params);
  },
  // 更新图片、区域、文字通用方法，pptId,slideId和id 必需
  slideWrapUpdateSlideElement(asyncParams, elementSty) {
    if (elementSty === 'ppt-picture') {
      return requestInstance.post('/api/schemeshow/slideWrap/updateSlideImage', asyncParams);
    }
    if (elementSty === 'ppt-text') {
      return requestInstance.post('/api/schemeshow/slideWrap/updateSlideText', asyncParams);
    }
    if (elementSty === 'ppt-background') {
      return requestInstance.post('/api/schemeshow/slideWrap/update', asyncParams);
    }
    if (elementSty === 'ppt-table') {
      const params = {
        ...asyncParams,
      };
      return requestInstance.post('/api/schemeshow/slideWrap/updateSlideTable', params);
    }
    return requestInstance.post('/api/schemeshow/slideWrap/updateSlideArea', asyncParams);
  },
  // 删除幻灯片的元素，id，pptId，slideId，type 是必须的
  slideWrapDelSlideInfo(params) {
    return requestInstance.post('/api/schemeshow/slideWrap/delSlideInfo', params);
  },
  // slide 元素排序，pptId，slideId 必须，排序元素id，zIndex，type 必须
  slideWrapSlideInfoSort(params) {
    return requestInstance.post('/api/schemeshow/slideWrap/slideInfoSort', params);
  },
  // 更新报价
  updateSlideTableSchemeInfo(params) {
    return requestInstance.post('api/schemeshow/slideWrap/updateSlideTableSchemeInfo', params);
  },
  // 判断表格是否存在XML对象
  updateSlideTableCheck(params) {
    return requestInstance.post('api/schemeshow/slideWrap/updateSlideTableCheck', params);
  },
};
